export default __webpack_public_path__ + "static/media/arrow-dropdown.04349e83.svg";